<span class="float-start">
  <span [className]="disabled ? 'input-name disabled': 'input-name' ">{{name}}</span>
</span>
<span class="float-start switchBox">
  <label class="switch">
    <input type="checkbox" [(ngModel)]="value" [disabled]="!!disabled" (change)="onSaveModel()">
    <span class="slider round test"></span>
  </label>
</span>